import { useMutation, useQuery, useQueryClient } from "react-query"
import { TrainingType } from "../api/trainingType"
import { useState } from "react"
import { TTrainingType } from "../shared/types/training.type"
import { get } from "lodash"
import { toast } from "react-toastify"
import { t } from "i18next"
import { hydraTransform } from "../shared/utils/hydraTransformer"

export const UseTrainingType = (enableQuery: boolean = false, trainer?: string) => {

    const queryClient = useQueryClient()


    const query = useQuery(['training_types'], () => TrainingType.getTrainingTypes(trainer), {
        refetchOnWindowFocus: false,
        cacheTime: 900000,
        enabled: enableQuery,
        keepPreviousData: true
    })


    //Mutations
    const createTrainingTypeMutation = useMutation((data: Partial<TTrainingType>) => TrainingType.createTrainingTypes(data))

    const updateTrainingTypeMutation = useMutation((data: Partial<TTrainingType>) => TrainingType.updateTrainingTypes(data))

    const deleteTrainingTypeMutation = useMutation((id: number) => TrainingType.delete(id))

    const create = async (data: Partial<TTrainingType>) => {
        return createTrainingTypeMutation.mutateAsync(data)
            .then(result => {
                queryClient.refetchQueries(['training_types'])
                return result
            }).catch(err => {
                toast(t('error:generic'), { type: 'error' })
                return err

            })
    }

    const update = async (data: Partial<TTrainingType>) => {
        return updateTrainingTypeMutation.mutateAsync(data)
            .then(result => {
                queryClient.refetchQueries(['training_types'])
                return result

            }).catch(err => {
                toast(t('error:generic'), { type: 'error' })
                return err
            })
    }

    const remove = async (id: number) => {
        return deleteTrainingTypeMutation.mutateAsync(id).then(() => {
            queryClient.invalidateQueries({
                queryKey: ['training_types']
            })
            return true
        }).catch(err => {
            toast(t('error:generic'), { type: 'error' })
            return err
        })
    }


    return {
        isLoading: query.isLoading || query.isFetching,
        isError: query.isError,
        trainingTypes: hydraTransform(query.data?.data ?? []),
        create,
        isCreating: createTrainingTypeMutation.isLoading,
        update,
        isUpdating: updateTrainingTypeMutation.isLoading,
        remove,
        isDeleting: deleteTrainingTypeMutation.isLoading
    }
}